import React, { useState } from 'react';
import { Checkbox } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { GroupText } from 'app/components/group-text/group-text';
import { SelectSingle } from 'app/area/shared/translated-components';
import { endpoints } from '../endpoints';
import { CompanyReportFormIds } from '../constants';
import { CompanyReportSection } from '../types';

import styles from './company-report-dynamic-periods.scss';

export const CompanyReportDynamicPeriods: React.FC<CompanyReportSection> = ({
  companyReportItem, options, validation, translation, loadOptions, resetValidation, updateItem }) => {

  const [accessTypeOptions, setAccessTypeOptions] = useState<LoadOptions>();

  const onUseDynamicPeriodsChange = (value: number) => {
    resetValidation(CompanyReportFormIds.predefinedDate);
    updateItem({ usePredefDate: !!value, predefinedDate: undefined });
  };

  const onDynamicPeriodsDefaultChange = (predefDateDefault: ComplexValue<number>) => {
    updateItem({ predefinedDate: predefDateDefault });
  };

  const onDynamicPeriodsDefaultLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(CompanyReportFormIds.predefinedDate, endpoints.dbFunction, loadOptionsParams);
    setAccessTypeOptions(loadOptionsParams);
  };

  return <div className={`${styles.wrapper} container main-grid`}>
    <TileWrapper>
      <div className="row">
        <div className="col-md-12">
          <GroupText>{translation.dynamic_periods}</GroupText>
          <div className={styles.dynamicPeriods}>
            <div className="row mt-3">
              <div className="col-lg-6 col-sm-12">
                <Checkbox
                  className={undefined}
                  componentId={CompanyReportFormIds.usePredefDate}
                  value={companyReportItem?.usePredefDate ? 1 : 0}
                  info={{ text: translation.dynamic_periods_use_info, visible: true }}
                  label={{ text: translation.dynamic_periods_use_label, visible: true }}
                  validation={validation?.[CompanyReportFormIds.usePredefDate]}
                  onChange={onUseDynamicPeriodsChange}
                />
              </div>
              <div className="col-lg-6 col-sm-12">
                <SelectSingle
                  componentId={CompanyReportFormIds.predefinedDate}
                  className={undefined}
                  info={{ text: translation.dynamic_periods_info_text, visible: true }}
                  label={{ text: translation.dynamic_periods_default }}
                  valueItem={isDefinedIncludingZero(companyReportItem?.predefinedDate?.value) && companyReportItem.predefinedDate}
                  onChange={onDynamicPeriodsDefaultChange}
                  validation={validation?.[CompanyReportFormIds.predefinedDate]}
                  placeholder={translation?.search}
                  readOnly={!companyReportItem?.usePredefDate}
                  options={options?.[CompanyReportFormIds.predefinedDate]?.codes as ComplexValue<number>[] || []}
                  fetching={options?.[CompanyReportFormIds.predefinedDate]?.fetching}
                  loadOptions={accessTypeOptions}
                  onLoadOptions={onDynamicPeriodsDefaultLoadOptions} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TileWrapper>
  </div>;
};
